import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_DAILY_REPORTS = 'GET_DAILY_REPORTS';
export const GET_DAILY_REPORT = 'GET_DAILY_REPORT';
export const CREATE_DAILY_REPORT = 'CREATE_DAILY_REPORT';
export const UPDATE_DAILY_REPORT = 'UPDATE_DAILY_REPORT';
export const DELETE_DAILY_REPORT = 'DELETE_DAILY_REPORT';
export const APPROVE_DAILY_REPORT = 'APPROVE_DAILY_REPORT';

// Get all daily reports
export const getDailyReports = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchDailyReports(searchQuery, page, pageSize);
    
    dispatch({ 
      type: GET_DAILY_REPORTS, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching daily reports:', error);
    throw error;
  }
};

// Get single daily report
export const getDailyReport = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchDailyReport(id);
    
    dispatch({ 
      type: GET_DAILY_REPORT, 
      payload: data 
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching daily report:', error);
    throw error;
  }
};

// Create daily report
export const createDailyReport = (reportData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createDailyReport(reportData);
    
    dispatch({ 
      type: CREATE_DAILY_REPORT, 
      payload: data 
    });
    
    openSnackbar('Daily report created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Daily report created successfully"));
    
    return data;
  } catch (error) {
    console.error('Error creating daily report:', error);
    openSnackbar('Error creating daily report', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating daily report"));
    throw error;
  }
};

// Update daily report
export const updateDailyReport = (id, reportData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateDailyReport(id, reportData);
    
    dispatch({ 
      type: UPDATE_DAILY_REPORT, 
      payload: data 
    });
    
    openSnackbar('Daily report updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Daily report updated successfully"));
    
    return data;
  } catch (error) {
    console.error('Error updating daily report:', error);
    openSnackbar('Error updating daily report', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating daily report"));
    throw error;
  }
};

// Delete daily report
export const deleteDailyReport = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteDailyReport(id);
    
    dispatch({ 
      type: DELETE_DAILY_REPORT, 
      payload: id 
    });
    
    openSnackbar('Daily report deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Daily report deleted successfully"));
  } catch (error) {
    console.error('Error deleting daily report:', error);
    openSnackbar('Error deleting daily report', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting daily report"));
    throw error;
  }
};

// Approve daily report
export const approveDailyReport = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.approveDailyReport(id);
    
    dispatch({ 
      type: APPROVE_DAILY_REPORT, 
      payload: data 
    });
    
    openSnackbar('Daily report approved successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Daily report approved successfully"));
    
    return data;
  } catch (error) {
    console.error('Error approving daily report:', error);
    openSnackbar('Error approving daily report', SNACKBAR_DURATION_MS, getSnackbarColor("Error approving daily report"));
    throw error;
  }
};

// Get reports by date range
export const getReportsByDateRange = (startDate, endDate, projectId) => async (dispatch) => {
  try {
    const { data } = await api.fetchReportsByDateRange(startDate, endDate, projectId);
    
    return data;
  } catch (error) {
    console.error('Error fetching reports by date range:', error);
    throw error;
  }
};

// Get monthly report summary
export const getMonthlyReportSummary = (month, year, projectId) => async (dispatch) => {
  try {
    const { data } = await api.fetchMonthlyReportSummary(month, year, projectId);
    
    return data;
  } catch (error) {
    console.error('Error fetching monthly report summary:', error);
    throw error;
  }
};
